<template>
  <section class="hero-images">
    <svg v-if="payload.icons === 'blue'" class="shape-1" width="263" height="437" viewBox="0 0 263 437" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M331.954 210.333C345.579 213.901 359.193 214.402 372.649 215.646C401.617 218.321 430.586 221.544 459.767 220.989C465.674 220.871 471.328 221.916 476.635 224.707C489.05 231.218 495.969 244.884 493.9 258.97C491.862 272.7 480.89 283.976 466.996 286.092C462.215 286.819 457.335 286.739 452.488 286.853C424.27 287.534 396.296 284.275 368.229 282.147C366.334 281.992 364.376 281.967 362.515 282.231C362.098 282.297 361.334 284.173 361.592 284.463C363.88 286.941 366.264 289.354 368.808 291.638C384.01 305.275 399.275 318.847 414.477 332.484C417.375 335.09 420.242 337.759 422.725 340.721C432.333 352.312 433.19 367.84 425.112 380.171C417.48 391.822 403.245 397.233 389.395 393.762C382.647 392.075 376.92 388.543 371.767 383.912C346.453 361.14 321.202 338.304 295.792 315.629C287.805 308.521 279.37 301.932 271.063 295.213C269.646 294.055 267.811 292.447 265.955 294.197C265.091 295.008 264.712 296.72 264.684 298.012C264.476 311.671 264.235 325.331 264.316 339.021C264.437 364.143 259.546 388.474 252.825 412.489C251.652 416.659 250.03 420.894 247.731 424.519C237.003 441.283 213.245 440.98 202.655 424.13C199.491 419.104 197.578 413.589 197.396 407.584C197.145 400.255 196.83 392.958 196.997 385.628C197.497 363.669 198.254 341.709 198.883 319.75C198.967 316.359 198.923 312.937 198.75 309.514C198.647 307.513 196.138 306.166 194.44 307.205C191.141 309.251 187.906 311.426 184.703 313.6C164.686 327.394 144.541 340.995 123.588 353.307C117.725 356.751 111.798 360.13 105.611 362.864C92.6936 368.593 79.1781 368.705 65.651 365.556C61.5061 364.602 57.3255 362.615 53.8495 360.141C38.8509 349.442 39.7385 328.063 55.3712 318.385C59.5357 315.819 64.1209 314.221 68.9332 313.267C74.2588 312.215 79.0665 309.938 83.4212 306.694C105.963 289.791 128.504 272.856 151.014 255.856C151.654 255.37 151.746 254.175 152.096 253.301C150.321 250.466 147.111 250.736 144.477 250.229C112.512 244.304 80.5475 238.54 48.5514 232.841C44.2788 232.081 39.8166 232.194 35.544 231.434C30.3079 230.548 24.9115 229.728 19.993 227.905C8.00224 223.427 0.546544 212.248 0.405908 199.72C0.262873 186.514 8.02441 175.25 20.6889 170.523C26.6525 168.306 32.8778 167.477 39.2332 167.099C54.8969 166.172 70.1876 168.734 85.4473 171.586C97.7836 173.899 110.152 176.116 122.456 178.365C123.5 174.067 120.637 172.494 118.736 170.531C100.756 152.028 82.7764 133.525 64.7007 115.12C56.4843 106.721 49.3887 97.4789 43.3495 87.3935C39.7647 81.4003 37.9439 74.9165 38.1758 67.8765C38.8098 47.4348 59.1236 35.9969 76.7217 46.4288C81.29 49.125 85.3799 52.6947 89.3413 56.2649C114.334 78.6501 139.326 101.1 164.158 123.68C176.43 134.809 189.116 145.387 202.25 155.447C203.409 156.315 204.6 157.15 205.855 157.921C208.59 159.623 210.802 158.711 210.92 155.74C211.066 151.832 211.02 147.925 211.039 144.018C210.937 115.216 210.995 86.413 210.669 57.6116C210.57 47.7312 211.787 38.1045 213.969 28.6036C216.751 16.4851 223.621 7.25812 235.581 2.92126C257.64 -5.10007 281.489 11.6709 279.004 35.0898C275.088 71.6881 277.978 108.23 277.016 144.785C276.96 147.24 276.905 149.662 277.042 152.115C277.278 155.408 275.721 159.74 278.777 161.635C282.316 163.85 284.806 159.708 287.271 157.762C310.962 139.111 334.492 120.268 357.087 100.233C362.56 95.4022 368.001 90.5395 373.602 85.8699C376.579 83.4054 379.717 80.9403 383.114 79.1846C396.669 72.1943 411.958 74.3036 422.267 84.3416C432.318 94.1221 435.554 110.352 430.175 123.578C426.547 132.471 420.827 140.047 412.463 144.242C401.823 149.543 393.279 157.419 384.219 164.684C367.892 177.755 351.726 191.051 335.528 204.282C334.088 205.482 332.261 206.49 331.953 210.269L331.954 210.333Z" fill="#BDD4EF"/>
    </svg>
    <svg v-if="payload.icons === 'yellow'" class="shape-1" width="263" height="437" viewBox="0 0 263 437" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M331.954 210.333C345.579 213.901 359.193 214.402 372.649 215.646C401.617 218.321 430.586 221.544 459.767 220.989C465.674 220.871 471.328 221.916 476.635 224.707C489.051 231.218 495.969 244.884 493.9 258.97C491.862 272.7 480.89 283.976 466.996 286.092C462.215 286.819 457.335 286.739 452.488 286.853C424.27 287.534 396.296 284.275 368.229 282.147C366.335 281.992 364.376 281.967 362.515 282.231C362.098 282.297 361.334 284.173 361.592 284.463C363.88 286.941 366.264 289.354 368.809 291.638C384.01 305.275 399.276 318.847 414.477 332.484C417.376 335.09 420.242 337.759 422.725 340.721C432.333 352.312 433.191 367.84 425.112 380.171C417.48 391.822 403.245 397.233 389.396 393.762C382.648 392.075 376.921 388.543 371.768 383.912C346.453 361.14 321.202 338.304 295.792 315.629C287.805 308.521 279.37 301.932 271.063 295.213C269.647 294.055 267.811 292.447 265.955 294.197C265.091 295.008 264.712 296.72 264.684 298.012C264.476 311.671 264.235 325.331 264.316 339.021C264.437 364.143 259.547 388.474 252.825 412.489C251.652 416.659 250.03 420.894 247.731 424.519C237.004 441.283 213.245 440.98 202.655 424.13C199.491 419.104 197.578 413.589 197.396 407.584C197.145 400.255 196.83 392.958 196.997 385.628C197.497 363.669 198.255 341.709 198.883 319.75C198.967 316.359 198.923 312.937 198.75 309.514C198.647 307.513 196.138 306.166 194.44 307.205C191.141 309.251 187.906 311.426 184.703 313.6C164.687 327.394 144.541 340.995 123.588 353.307C117.725 356.751 111.798 360.13 105.612 362.864C92.6938 368.593 79.1783 368.705 65.6512 365.556C61.5064 364.602 57.3257 362.615 53.8497 360.141C38.8512 349.442 39.7387 328.063 55.3715 318.385C59.536 315.819 64.1212 314.221 68.9335 313.267C74.2591 312.215 79.0668 309.938 83.4215 306.694C105.963 289.791 128.505 272.856 151.014 255.856C151.654 255.37 151.747 254.175 152.097 253.301C150.321 250.466 147.111 250.736 144.477 250.229C112.512 244.304 80.5478 238.54 48.5516 232.841C44.279 232.081 39.8169 232.194 35.5443 231.434C30.3081 230.548 24.9117 229.728 19.9933 227.905C8.00248 223.427 0.546789 212.248 0.406152 199.72C0.263117 186.514 8.02466 175.25 20.6892 170.523C26.6528 168.306 32.8781 167.477 39.2334 167.099C54.8971 166.172 70.1878 168.734 85.4475 171.586C97.7838 173.899 110.152 176.116 122.456 178.365C123.5 174.067 120.637 172.494 118.736 170.531C100.756 152.028 82.7766 133.525 64.7009 115.12C56.4846 106.721 49.3889 97.4789 43.3497 87.3935C39.7649 81.4003 37.9441 74.9165 38.1761 67.8765C38.8101 47.4348 59.1239 35.9969 76.7219 46.4288C81.2903 49.125 85.3801 52.6947 89.3416 56.2649C114.334 78.6501 139.326 101.1 164.159 123.68C176.43 134.809 189.116 145.387 202.251 155.447C203.409 156.315 204.6 157.15 205.855 157.921C208.59 159.623 210.802 158.711 210.92 155.74C211.067 151.832 211.021 147.925 211.039 144.018C210.937 115.216 210.996 86.413 210.669 57.6116C210.57 47.7312 211.788 38.1045 213.969 28.6036C216.752 16.4851 223.621 7.25812 235.581 2.92126C257.641 -5.10007 281.489 11.6709 279.004 35.0898C275.088 71.6881 277.978 108.23 277.016 144.785C276.961 147.24 276.905 149.662 277.042 152.115C277.278 155.408 275.721 159.74 278.777 161.635C282.317 163.85 284.806 159.708 287.271 157.762C310.963 139.111 334.493 120.268 357.087 100.233C362.56 95.4022 368.001 90.5395 373.603 85.8699C376.58 83.4054 379.717 80.9403 383.114 79.1846C396.669 72.1943 411.958 74.3036 422.267 84.3416C432.319 94.1221 435.554 110.352 430.175 123.578C426.547 132.471 420.827 140.047 412.463 144.242C401.823 149.543 393.279 157.419 384.219 164.684C367.892 177.755 351.726 191.051 335.528 204.282C334.088 205.482 332.261 206.49 331.954 210.269L331.954 210.333Z" fill="#FCC157"/>
    </svg>
    <b-container>
      <b-row align-h="center">
        <b-col class="content d-flex flex-column justify-content-between text-center" cols="12" xl="6">
          <div class="content__box d-flex flex-column align-items-center text-center">
            <div class="content__title-box">
              <img v-if="payload.image" class="content__title-box-image" :src="payload.image.url" :alt="payload.image.alt" />
<!--              <img v-if="payload.show_label" class="content__logo" src="../../assets/media/logo/ep-logo-black.svg" alt="EP logo" />-->
              <h1 class="content__title" v-if="payload.title" v-html="payload.title" />
            </div>
          </div>
<!--          <div class="d-flex justify-content-center">-->
<!--            <img @click="scrollToSecondSection" class="content__arrow" alt="chevron-down-icon" role="button"-->
<!--                 src="../../assets/media/icons/chevron-down.svg"/>-->
<!--          </div>-->
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "HeroImages",
  props: ['payload'],
  methods: {
    scrollToSecondSection() {
      const sections = document.querySelectorAll('main section');
      if (sections.length > 1) {
        sections[1].scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style lang="scss">
section.hero-images{
  position: relative;
  background: $main-bg;
  color: $main-color;
  padding-top: 80px;
  padding-bottom: 80px;
  z-index: 1;

  @include media-breakpoint-up(lg){
    padding-top: 137px;
    padding-bottom: 24px;
  }

  .shape-1 {
    position: absolute;
    top: 25%;
    right: 0;

    @include media-breakpoint-down(md){
      height: 60%;
    }
  }

  h1 {
    @extend %header-1;
    z-index: 1;

    & span {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: -5%;
        right: 0;
        bottom: 10%;
        height: 100%;
        width: 110%;
        background-image: url("data:image/svg+xml,%3Csvg width='514' height='54' viewBox='0 0 514 54' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.4584 53.4066C134.162 51.5796 245.865 49.7527 357.569 47.9257C389.491 47.4037 421.398 46.8818 453.319 46.3597C479.223 45.9351 500.377 34.8174 508.107 24.6399C511.891 19.6704 515.526 13.5205 511.293 8.4619C508.202 4.76872 501.924 0.686467 491.509 0.855636C379.805 2.68259 268.102 4.50951 156.398 6.33646C124.476 6.85853 92.5696 7.38044 60.6479 7.9025C34.7443 8.32711 13.5906 19.4448 5.86034 29.6223C2.07637 34.5918 -1.55854 40.7417 2.67429 45.8003C5.76516 49.4935 12.0429 53.5757 22.4584 53.4066Z' fill='%23BDD4EF'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: contain;
        z-index: -1;
        pointer-events: none;

        @include media-breakpoint-down(sm){
          display: none;
        }
      }
    }
  }

  .content {
    position: relative;
    z-index: 3;
    gap: 32px;

    @include media-breakpoint-up(lg){
      padding: 0;
      min-height: 440px;
    }

    &__box {
      gap: 40px;
    }

    &__logo {
      position: absolute;
      top: -80%;
      left: 0;
      max-width: 115px;
      object-fit: cover;
    }

    &__title-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 40px 0 0 0;
      position: relative;

      & .content__title {
        position: absolute;
        left: -35%;
        bottom: 0;

        @include media-breakpoint-down(lg){
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 100%;
        }

        @include media-breakpoint-down(md){
          bottom: -15%;
        }

        @include media-breakpoint-down(sm){
         position: relative;
        }
      }

      &-image {
        object-fit: cover;
        max-width: 710px;
        border-radius: 8px;
        transform: rotate(1.5deg);

        @include media-breakpoint-down(lg){
          width: 100%;
        }
      }
    }

    &__arrow {
      padding: 9px;
      border-radius: 360px;
      background: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .box {
    display: flex;
    justify-content: center;
  }

  .button {
    font-size: 20px;
    color: white;
    font-weight: 500;
    padding: 10px 32px;
    background-color: #007CC2;
    border-radius: 40px;
  }

  .image-left-one {
    object-fit: cover;
    transform: rotate(6.748deg);
    border-radius: 8px;
    z-index: 1;
  }

  .image-left-two {
    position: absolute;
    width: 256px;
    height: 256px;
    object-fit: cover;
    border-radius: 8px;
    top: 425px;
    left: 8px;
    z-index: 2;
  }

  .image-left-three {
    position: absolute;
    width: 160px;
    height: 160px;
    transform: rotate(-4.963deg);
    border-radius: 8px;
    z-index: 3;
    top: 603px;
    left: 227px;
    object-fit: cover;

    @include media-breakpoint-down(sm){
      left: 30%;
    }
  }

  .image-right-one {
    position: absolute;
    border-radius: 8px;
    width: 256px;
    height: 256px;
    transform: rotate(-4.605deg);
    object-fit: cover;
    z-index: 1;
    top: 137px;
    right: 21px;

    @include media-breakpoint-down(sm){
      display: none;
    }
  }

  .image-right-two {
    position: absolute;
    border-radius: 8px;
    width: 160px;
    height: 160px;
    transform: rotate(7.874deg);
    object-fit: cover;
    z-index: 2;
    top: 387px;
    right: 116px;

    @include media-breakpoint-down(sm){
      display: none;
    }
  }
}
</style>
